import { render, staticRenderFns } from "./NodeForm.vue?vue&type=template&id=e328c686&"
import script from "./NodeForm.vue?vue&type=script&lang=js&"
export * from "./NodeForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\嘀嗒嘀关务\\ddd_cms_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e328c686')) {
      api.createRecord('e328c686', component.options)
    } else {
      api.reload('e328c686', component.options)
    }
    module.hot.accept("./NodeForm.vue?vue&type=template&id=e328c686&", function () {
      api.rerender('e328c686', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/other/drag/components/NodeForm.vue"
export default component.exports